import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

export const MesoMedicsSection = ({ t }) => {
  return (
    <section id="mesomedics" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <img 
            src="https://customer-assets.emergentagent.com/job_67b366a2-9c46-4ca8-9e2f-e7e30db89ded/artifacts/xlka8v7r_Mesomedics%20logo%20IMAGEN%20PNG.png" 
            alt="MesoMedics - Pure Science for Skin Perfect"
            className="h-44 w-auto mx-auto mb-6 rounded-lg"
            data-testid="mesomedics-logo"
          />
          <p className="text-xl text-slate-700 font-semibold mb-4">
            {t.mesomedics.subtitle}
          </p>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            {t.mesomedics.description}
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.mesomedics.products.map((product, index) => (
            <Card 
              key={index} 
              data-testid={`mesomedics-product-${index}`}
              className="group hover:shadow-2xl transition-all duration-300 border-2 border-slate-200 hover:border-slate-700 relative overflow-hidden"
            >
              {/* Product Image */}
              {product.image && (
                <div className="flex items-center justify-center p-6 h-64 overflow-hidden relative">
                  <img src="https://customer-assets.emergentagent.com/job_67b366a2-9c46-4ca8-9e2f-e7e30db89ded/artifacts/sb4uob6v_Dise%C3%B1o%20sin%20t%C3%ADtulo%20%2821%29.png" alt="" className="absolute inset-0 w-full h-full object-cover" />
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="relative h-full w-auto object-contain group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              )}
              <CardHeader className="relative z-10 pt-4 pb-2">
                <CardTitle className="text-lg text-slate-900">{product.name}</CardTitle>
                {product.subtitle && (
                  <Badge className="w-fit bg-slate-800 text-white text-xs">{product.subtitle}</Badge>
                )}
                <CardDescription className="text-sm pt-2 text-slate-600 leading-relaxed">{product.description}</CardDescription>
              </CardHeader>
              <CardContent className="relative z-10 space-y-3">
                <div className="space-y-1.5">
                  {product.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-start space-x-2">
                      <CheckCircle2 className="w-4 h-4 text-slate-700 flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-slate-600">{benefit}</span>
                    </div>
                  ))}
                </div>
                {(product.usage || product.presentation) && (
                  <div className="pt-2 border-t border-slate-100 space-y-1">
                    {product.usage && (
                      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">{product.usage}</p>
                    )}
                    {product.presentation && (
                      <p className="text-xs text-slate-500">{product.presentation}</p>
                    )}
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
